import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { ServiceWorkerModule } from '@angular/service-worker';
// ui boosts
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkTreeModule } from '@angular/cdk/tree';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ClipboardModule } from 'ngx-clipboard';

// Mtic3 App Modules
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { MarkdownModule, MarkedOptions } from 'ngx-markdown';
import { UiLoginModule } from './ui-login/ui-login.module';
import { UiPartialModule } from './ui-partial/ui-partial.module';
import { UiHierarchyChatModule } from './ui-hierarchy-chat/ui-hierarchy-chat.module';

import { GraphModule } from './graph/graph.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularSplitModule } from 'angular-split';
import { UiWhitelabelEnsModule } from './ui-whitelabel-ens/ui-whitelabel-ens.module';


export const ngMarkDownOptions = {
  markedOptions: {
    provide: MarkedOptions,
    useValue: {
      gfm: true,
      tables: true,
      breaks: false,
      pedantic: false,
      sanitize: false,
      smartLists: true,
      smartypants: false,
    },
  },
}

// IMPORTANT
// Add your own project credentials to environments/*.ts

@NgModule({
    declarations: [
        AppComponent
    ],
    providers: [
        {provide: LocationStrategy, useClass: HashLocationStrategy}
    ],
    imports: [
        BrowserModule.withServerTransition({appId: 'serverApp'}),
        BrowserTransferStateModule,
        AppRoutingModule,
        HttpClientModule,

        CoreModule,
        UiPartialModule,
        UiLoginModule,
        UiHierarchyChatModule,
        UiWhitelabelEnsModule,

        BrowserAnimationsModule,
        MarkdownModule.forRoot(ngMarkDownOptions),
        AngularSplitModule.forRoot(),
        ClipboardModule,

        FullCalendarModule,
        DragDropModule,
        CdkTreeModule,
        FormsModule,
        ReactiveFormsModule,
        GraphModule,
    ],
    exports: [
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
